import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getAuth, Auth } from 'firebase/auth';

// Firebase configuration
// Replace these values with your own Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDRonifzpgocqjKEntEoWYQP3EWiFpw7n4",
  authDomain: "puntos-2bd2d.firebaseapp.com",
  projectId: "puntos-2bd2d",
  storageBucket: "puntos-2bd2d.firebasestorage.app",
  messagingSenderId: "631912974063",
  appId: "1:631912974063:web:629c480cd6970869683d1a"
};

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db: Firestore = getFirestore(app);
export const auth: Auth = getAuth(app);

export default app;
